import { render, staticRenderFns } from "./DStats.vue?vue&type=template&id=58af07e1&"
import script from "./DStats.vue?vue&type=script&lang=js&"
export * from "./DStats.vue?vue&type=script&lang=js&"
import style0 from "./DStats.vue?vue&type=style&index=0&id=58af07e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports